module.exports = {
    'CIRBE_SIGNATURE_FAILED': 'Ha ocurrido un error en la transacción. Por favor intente nuevamente',
    PARAMS_VALUES: {
        CLIENT: 'CLIENTE',
        RNC: 'RNC'
    }
}
